import { companyBenchmarksEndpoints } from "@/constants";
import { listBenchmarksByEndpointHandler } from "@/services/admin-benchmarks";
import type { BenchmarksPageType, ListBenchmarksParamsType } from "@/types";

export const listCompanyBenchmarksHandler = (params: ListBenchmarksParamsType = {}): Promise<BenchmarksPageType> => listBenchmarksByEndpointHandler(
    companyBenchmarksEndpoints.base,
    params,
);
